import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@openfin/ui-library';

import { ButtonOptions } from '../../../../client';
import { SectionAlignment } from '../../../../client/templates/templates';

import { CardButtonGroup } from './CardButtonGroup';
import { Immutable } from '@openfin/predux';

interface ButtonContainerProps extends NftOnClick {
  buttonData?: Required<ButtonOptions>[] | readonly Immutable<Required<ButtonOptions>>[];
  alignment?: SectionAlignment;
}

interface NftOnClick {
  onClick: (event: React.MouseEvent, button: Required<ButtonOptions>) => void;
}

const mapAlignment = (alignment: SectionAlignment) => {
  switch (alignment) {
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    case 'center':
      return 'center';
  }
};

export type NftButtonOptions = NftOnClick & Required<ButtonOptions>;

export const ButtonsContainer: React.FC<ButtonContainerProps> = (props) => {
  const { buttonData = [], alignment = 'right', onClick } = props;
  const buttonDataGrouped: [
    cta: NftButtonOptions[],
    nonCta: NftButtonOptions[]
  ] = React.useMemo(() => {
    const groups: [cta: NftButtonOptions[], nonCta: NftButtonOptions[]] = [[], []];
    buttonData?.forEach((x) => {
      const index = x.cta ? 0 : 1;
      groups[index].push({ ...x, onClick });
    });

    return groups;
  }, [buttonData]);

  return (
    <Container justifyContent={mapAlignment(alignment)}>
      <CardButtonGroup buttons={buttonDataGrouped[1]} />
      <CardButtonGroup buttons={buttonDataGrouped[0]} />
    </Container>
  );
};

const Container = styled(Box)`
  margin-top: auto;
  align-self: flex-end;
  justify-self: flex-end;
  width: 100%;
  gap: ${(props) => props.theme.px.base};
`;
